import ChatEmojiSound from "./chat_emoji_sound";

const {ccclass, property} = cc._decorator;

@ccclass
export class EmojiCell extends cc.Component {
    @property(cc.String)
    emoji_id:string = '';

    isHasPlay:boolean=false

    @property(cc.Integer)
    delayTime:number = 0;

    @property([cc.String])
    soundName:string[] = [];

    @property(cc.Boolean)
    isNeedExpSound:boolean = false;

    playArriveEmoji()
    {
        let armatureDisPlay = this.getComponent(dragonBones.ArmatureDisplay)
        armatureDisPlay.addEventListener(dragonBones.EventObject.COMPLETE, this.animationEventHandler, this);
        
        //armatureDisPlay.animationName="play"
        
        //this.armature.animation.fadeIn('boom', -1, -1, 0, 'hit');
        armatureDisPlay.playAnimation("boom",1)
        let soundNmae=this.getSound()
        if(!this.isHasPlay)
        {
            ChatEmojiSound.playBomb(soundNmae)
        }
    }
    private animationEventHandler(event) {
       
        if (event.type === dragonBones.EventObject.COMPLETE) {
            if (event.animationState.name === "boom") {
                cc.log("attack 动作播放完毕！！！");          
                this.node.active=false
                this.node.destroy()
            }
        }
    }

    playAnim(targetPos:cc.Vec2){
        this.node.stopAllActions();
        let anim = this.node.getComponent(cc.Animation);
        anim.pause();
        anim.setCurrentTime(0);
        let animClips = anim.getClips();
        anim.on('finished',(params:any)=>{
            if (animClips.length > 1) {
                if (anim.currentClip.name == animClips[1].name){
                    this.node.active=false
                    this.node.destroy()
                }else{
                    let delay = cc.delayTime(this.delayTime);
                    let seq = cc.sequence(delay,cc.callFunc(()=>{
                        this.node.position=targetPos;
                        this.playSound(1,this.isNeedExpSound);
                        anim.play(animClips[1].name);
                    }))
                    this.node.runAction(seq);
                }
            }else{
                this.node.active=false
                this.node.destroy()
            }
        },this);
        anim.play(animClips[0].name)
        this.playSound(0,this.isNeedExpSound);
    }

    playSound(index:number,isNeedExpSound:boolean){
        let soundName = this.soundName[index];
        if (soundName && isNeedExpSound) {
            ChatEmojiSound.playSound(soundName);
        }
    }

    playSoundByAnim(index:number){
        this.playSound(index,true)
    }

    getSound(str:string="")
    {
        if(str=="")
        {
            str==this.node.name
        }

        switch(this.node.name)
        {
            case "emoji0":
                return "dianzan_bomb"
            case "emoji1":
                return "feiwen_bomb"
            case "emoji2":
                return "poshui_bomb"
            case "emoji3":
                return "fanggou_bomb"
            case "emoji4":
                return "ganbei_bomb"
            case "emoji5":
                return "gaizhang_bomb"
            case "emoji6":
                return "dabian_bomb"
            case "emoji7":
                return "zhuaji_bomb"
            case "emoji8":
                return "zhadan_bomb"
            case "emoji9":
                return "songhua_bomb"
            case "emoji10":
                return "daodan_bomb"
        }
    }

    autoDestroy(){
        this.scheduleOnce(() => {
            this.node.active=false
            this.node.destroy()
        }, 3);
    }
}
